import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'spaceBeforeUppercase'
})
export class SpaceBeforeUpperCasePipe implements PipeTransform {

  transform(value: string): string {
    if (!value) {return '';}

    let result = '';
    for (let i = 0; i < value.length; i++) {
      const char = value[i];
      if (char.toUpperCase() === char && i > 0) {
        result += ' ';
      }
      result += char;
    }
    return result;
  }

}
